document.addEventListener('DOMContentLoaded', function () {

    // if system has not reduced motion set up
    const mediaPrefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')?.matches;
    
    if ( !mediaPrefersReducedMotion ) {
        // show animating elements when scrolled into view
        const animatingElements = document.querySelectorAll('.observer-animation');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('observer-animation--shown');
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.5
        });

        animatingElements.forEach(elem => {
            observer.observe(elem);
        });
    }

});